import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { faqCategories } from "./faqContent";
import "./FAQ.css";

function FAQ() {
  const [activeCategory, setActiveCategory] = useState(faqCategories[0].id);
  const [openQuestion, setOpenQuestion] = useState(null);

  const category = faqCategories.find((item) => item.id === activeCategory);

  const selectCategory = (id) => {
    setActiveCategory(id);
    setOpenQuestion(null);
  };

  return (
    <section id="faq" className="faq" aria-labelledby="faq-title">
      <Container>
        <header className="faq-header">
          <p className="eyebrow mb-2">Questions fréquentes</p>
          <h2 id="faq-title" className="faq-title">
            Tout ce qu'il faut savoir avant de commencer
          </h2>
        </header>

        <div className="faq-tabs" role="tablist" aria-label="Thèmes">
          {faqCategories.map((item) => (
            <button
              key={item.id}
              type="button"
              role="tab"
              aria-selected={item.id === activeCategory}
              className={`faq-tab ${item.id === activeCategory ? "is-active" : ""}`}
              onClick={() => selectCategory(item.id)}
            >
              {item.label}
            </button>
          ))}
        </div>

        <div className="faq-list" role="tabpanel">
          {category.questions.map(({ question, answer }, index) => {
            const isOpen = openQuestion === index;
            const panelId = `faq-${category.id}-${index}`;

            return (
              <div key={question} className="faq-item">
                <button
                  type="button"
                  className="faq-question"
                  aria-expanded={isOpen}
                  aria-controls={panelId}
                  onClick={() => setOpenQuestion(isOpen ? null : index)}
                >
                  <span>{question}</span>
                  <span className="faq-icon" aria-hidden="true">
                    {isOpen ? "−" : "+"}
                  </span>
                </button>
                {isOpen && (
                  <p id={panelId} className="faq-answer">
                    {answer}
                  </p>
                )}
              </div>
            );
          })}
        </div>

        <p className="faq-more">
          <Link to="/faq">Voir toutes les questions</Link>
        </p>
      </Container>
    </section>
  );
}

export default FAQ;
